import unlockedIcon from '@/assets/icons/unlocked/unlocked.svg';
import lockedLightIcon from '@/assets/icons/lock-light/lock-light.svg';
import lockedDarkIcon from '@/assets/icons/lock-dark/lock-dark.svg';
import { MissionRequirementsProps } from "./mission-requirements-types"
import { RequirementContainer, IconWrapper, NFTImage } from "./style-components";
import { useTheme } from '@/contexts/theme-context/useThemeContext';
import { Objective } from '@/types/objective/objective-type';
import { useGetNFT } from '@/hook/useGetNFT/useGetNFT';
import { useUserContext } from '@/contexts/user/useUserContext';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';

const EXTRACT_KEY = 'COLLECTION_KEY_';
const RenderIcons: React.FC<MissionRequirementsProps> = ({
	objective,
	main_key
}) => {
	const defaultNftImage = "https://placeholder.com/24x24";
	const theme = useTheme();
	const isDark = theme.theme.name === 'dark';
	const { type } = objective;
    const collectionKey = type?.split(EXTRACT_KEY)?.[1];
	const { nft, loading, isOwner } = useGetNFT(collectionKey, main_key ?? null);
	const thumbnail = nft?.[0]?.thumb_url || null;
	const getLockIcon = () => {
		if (isOwner) return unlockedIcon;
		return isDark ? lockedDarkIcon : lockedLightIcon;
	};

	return (
		<RequirementContainer>
			<IconWrapper $isCompleted={isOwner}>
				<img src={getLockIcon()} alt={isOwner ? "unlocked" : "locked"} />
			</IconWrapper>
			{loading ? 
			<Spin indicator={<LoadingOutlined style={{ fontSize: 18 }} spin />} size="small" /> :
			<NFTImage src={thumbnail ?? defaultNftImage} alt="Required NFT" />}
		</RequirementContainer>
	);
};

const MissionRequirements: React.FC<{ requirements: Objective[] }> = ({
	requirements
}) => {
	const { user } = useUserContext();
	return (
		requirements?.map((objective: Objective, index) => {
			return <RenderIcons 
				key={objective?.id || index} 
				objective={objective} 
				main_key={user?.main_key ?? null}
			/>
		})
	);
};

export default MissionRequirements;
